import React from "react";

const SingleChoiceQuestion = ({ question, value, onChange }) => {
  const { questionId, options = [] } = question;

  return (
    <div className="space-y-2">
      {options.map((option) => (
        <button
          key={option.value}
          onClick={() => onChange(questionId, option.value)}
          className={`w-full text-left px-4 py-3 rounded-lg transition-all border ${
            value === option.value
              ? "bg-spiders-primary-500/10 border-spiders-primary-500 text-spiders-text-primary"
              : "bg-spiders-bg-elevated border-transparent text-spiders-text-secondary hover:bg-spiders-bg-light"
          }`}
        >
          <div className="flex items-center gap-3">
            <div
              className={`w-4 h-4 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${
                value === option.value
                  ? "border-spiders-primary-500"
                  : "border-spiders-text-muted"
              }`}
            >
              {value === option.value && (
                <div className="w-2 h-2 rounded-full bg-spiders-primary-500" />
              )}
            </div>
            <span className="text-sm">{option.label}</span>
          </div>
        </button>
      ))}
    </div>
  );
};

export default SingleChoiceQuestion;
